import { axios } from '@Root/API'

export const getRolloverOptions = () => {
  return axios.get('rollover-leavers/info')
}
